{
  "Settings": "Einstellungen",
  "Select a tab": "Wähle einen Tab",
  "preferences": {
    "header": "Präferenzen",
    "baseCurrency": "Deine Basiswährung",
    "preferredLanguage": "Bevorzugte Sprache",
    "baselineDate": "Basisdatum",
    "expectedDateFormats": "Datumsformate in deinen Dateien",
    "expectedDateFormatsInfo": "Die Datenformate in deinen importierten Dateien können unterschiedlich sein. Bitte aktualisiere die Formate, die du in deinen Dateien erwartest, damit wir sie verwenden können, um die Daten in unser internes Format umzuwandeln. Wir werden sie nacheinander anwenden, bis wir ein korrektes Datum sehen, beginnend mit dem obersten und dann weiter nach unten.",
    "expectedDateFormatsAllowed": "Die App erkennt gängige Datumsformate, wie z.B. YYYY, MM, DD, zum Beispiel 'YYYY-MM-DD' oder 'DD.MM.YYYY'. Wir unterstützen",
    "expectedDateFormatsAllowedLink": "alle diese Formate.",
    "expectedDateFormatsError": "Verwende bitte nur unterstützte Formate."
  },
  "simulations": {
    "header": "Simulationen",
    "info": "Die folgenden Parameter werden in den Simulationen zur Berechnung des zukünftigen Wachstums deiner Vermögenswerte verwendet.",
    "slider": "Schieberegler",
    "setDates": "Lege das Start- und Enddatum für all deine Projekte, Simulationen und den Schieberegler fest.",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "inflation": "Inflation",
    "inflationEnabledDescription": "Wenn aktiviert, erhöht das System automatisch alle Ein- und Auszahlungen jedes Jahr um den angegebenen Prozentsatz. Dies gilt nicht für Ein- und Auszahlungen, für die eine individuelle Erhöhungsrate festgelegt ist.",
    "disabled": "Deaktiviert",
    "enabled": "Aktiviert",
    "simulatedInflationRate": "Simulierte Inflationsrate (%)",
    "averageInflation": "Die durchschnittliche Inflation in allen OECD-Ländern betrug von 1982-2022 3,55%, in der Eurozone 2,95% und in Deutschland 1,89%. Quelle",
    "source": "Quelle ",
    "stockMarketGrowthRate": "Wachstumsrate der Kategorien (%)",
    "simpleMode": "Einfacher Modus: setze einen Wachstumsfaktor für alle Anlagen (in allen Depots / Konten in derselben Kategorie).",
    "simpleMode2": "Anhand historischer Daten beträgt die langfristige jährliche Wachstumsrate des Aktienmarkts ca. 5-6%.",
    "advancedMode": "Expertenmodus: setze individuelle Wachstumsraten für jede Aktie / Kryptowährung. Diese gelten für dieses Asset in allen Depots / Konten in der Kategorie.",
    "advancedMode2": "Für Aktien / Kryptowährungen, für die es keine individuelle Wachstumsfaktoren gibt, gilt der allgemeine Wachstumsfaktor.",
    "growthRate": "Wachstumsrate der Kategorie (%)",
    "simple": "Einfach",
    "advanced": "Expert",
    "stockDividends": "Aktiendividenden",
    "stockDividendsDescription": "Einfacher modus: setze eine Dividendenrendite (in %) für alle Aktien. Wir setzen dann diese Rendite für alle Aktien in allen Depots ein, die mindestens einmal Dividende ausgezahlt haben.",
    "stockDividendsDescription2": "Expertenmodus: setze individuelle Dividendenrenditen (in %) für jede dividendenbringende Aktie. Diese Renditen gelten für alle Konten. Die Dividendenrendite werden in diesem Modus nur für hier definierten Aktien simuliert.",
    "dividendYield": "Dividendenrendite (%)",
    "symbol": "Symbol",
    "dividendPerYear": "Dividende (%)",
    "add": "Hinzufügen",
    "save": "Speichern",
    "cancel": "Abbrechen"
  },
  "account": {
    "header": "Nutzerkonto",
    "saveChanges": "Änderungen speichern",
    "2fa": "Zwei-Faktor-Authentifizierung",
    "changePassword": "Passwort ändern",
    "qrCode1": "Scanne den QR-Code mit deiner bevorzugten Authenticator-App (wie ",
    "qrCode2": "oder ",
    "manualEntry": "Wenn du den Code lieber manuell eingeben möchtest, verwende den folgenden Code.",
    "Enable": "Aktivieren",
    "Enabled": "Aktiviert",
    "Email address": "E-Mail-Adresse",
    "emailInfo": "Halt dein E-Mail-Konto bereit, wenn du deine E-Mail änderst -- wir schicken dir einen Bestätigungscode.",
    "pleaseEnterCode": "Bitte gib den Bestätigungscode aus deiner E-Mail ein.",
    "enterAuthCode": "Gib den Code aus deiner Authenticator-App ein, sobald du fertig bist:",
    "Confirm": "Bestätigen",
    "Submit": "Abschicken",
    "Username": "Benutzername",
    "Password": "Passwort",
    "Enter your current password": "Gib dein aktuelles Passwort ein",
    "Please enter your current password.": "Bitte gib dein aktuelles Passwort ein.",
    "The new password cannot be the same as the current password.": "Das neue Passwort darf nicht dasselbe wie das aktuelle Passwort sein.",
    "Enter new password": "Neues Passwort eingeben",
    "Repeat new password": "Neues Passwort wiederholen"
  },
  "billing": {
    "header": "Abo",
    "title": "Abo",
    "leadingText1": "Deine Privatsphäre ist uns wichtig. Nur unser spezialisiertes Payment-Provider Stripe hat Zugriff auf deine Zahlungsdaten.",
    "leadingText2": "Folge einen der folgenden Links, um deinen Plan direkt bei Stripe zu verwalten. Alle Links öffnen in einem neuen Tab.",
    "currentSubscription": "Aktueller Plan",
    "upgradePlan": "Plan upgraden",
    "paymentMethod": "Zahlungsmethode",
    "downloadInvoices": "Rechnungen herunterladen",
    "cancelSubscription": "Plan kündigen"
  }
}
